<template>
  <tr class="customer-ortho-elastic" :class="{ selected: is_selected }">
    <td class="customer-ortho-elastic__active">
      {{ is_active }}
    </td>
    <td class="customer-ortho-elastic__start">
      {{ date_start }}
    </td>
    <td class="customer-ortho-elastic__end">
      {{ date_end }}
    </td>
    <td class="customer-ortho-elastic__tooth1">
      {{ teeth }}
    </td>
    <td class="customer-ortho-elastic__length">
      {{ elastic.length }}
    </td>
    <td class="customer-ortho-elastic__tension">
      {{ elastic.tension }}
    </td>
    <td class="customer-ortho-elastic__position">
      {{ elastic.position }}
    </td>
    <td class="customer-ortho-elastic__type">
      {{ elastic_type }}
    </td>
    <td class="customer-ortho-elastic__actions">
      <button type="button" class="btn btn-wabident-round small" @click="$emit('edit', elastic)">
        Editar
      </button>
      <button type="button" class="btn btn-wabident-round small red" @click="$emit('delete', elastic)">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['elastic', 'customer', 'selected_tooth'],
  data() {
    return {}
  },
  computed: {
    teeth() {
      let ret = []
      const teeth = [
        this.elastic.tooth_1,
        this.elastic.tooth_2,
        this.elastic.tooth_3,
        this.elastic.tooth_4
      ];

      teeth.forEach((tooth) => {
        if (tooth != '') {
          ret.push(tooth);
        }
      });

      return ret.join(',');
    },
    is_selected() {
      if (!this.selected_tooth || this.selected_tooth.length <= 0) {
        return false;
      }

      return this.selected_tooth.includes(this.elastic.tooth_1) ||
        this.selected_tooth.includes(this.elastic.tooth_2) ||
        this.selected_tooth.includes(this.elastic.tooth_3) ||
        this.selected_tooth.includes(this.elastic.tooth_4);
    },
    is_active() {
      return this.elastic.is_current ? 'Sí' : 'No';
    },
    date_start() {
      if (this.elastic.date_start) {
        return window.WabiDent.fmtDate(this.elastic.date_start);
      }
      return '';
    },
    date_end() {
      if (this.elastic.date_end) {
        return window.WabiDent.fmtDate(this.elastic.date_end);
      }
      return '';
    },
    elastic_type() {
      const types = {
        elastic: 'Elástico',
        bracket: 'Bracket',
        extraction: 'Extracción',
      };

      return types[this.elastic.type] || 'N/D';
    }
  },
}
</script>

<style lang="scss">
.customer-ortho-elastic__actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
